export default "__VITE_ASSET__qWgkxv8M__"